import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FleetService} from "./services/fleet.service";
import {VehiclesListViewComponent} from './views/vehicles-list-view/vehicles-list-view.component';
import {VehiclesListComponent} from './components/vehicles-list/vehicles-list.component';
import {VisbosCoreModule} from "../core/visbos-core/visbos-core.module";
import {VehicleFormComponent} from './components/vehicle-form/vehicle-form.component';
import {OrganizationModule} from "../organization/organization.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CRMModule} from '../crm/crm.module';

@NgModule({
  imports: [
    CommonModule, ReactiveFormsModule, FormsModule,
    VisbosCoreModule, OrganizationModule, CRMModule
  ],
  declarations: [VehiclesListViewComponent, VehiclesListComponent, VehicleFormComponent],
  providers: [FleetService],
  exports: [VehiclesListViewComponent, VehiclesListComponent, VehicleFormComponent]
})
export class FleetModule {
}



// WEBPACK FOOTER //
// ./src/app/fleet/fleet.module.ts